import { createElement } from 'react';

function flexBoxHack(width: number, count: number) {
  const arr = [];
  const style = { width, height: 0 };
  for (let i = 0; i < count; i++) {
    arr.push(createElement('div', { style, key: i }));
  }
  return arr;
}

export default flexBoxHack;
